module.exports = __webpack_public_path__ + "static/media/Picture2.69db49d5.png";